import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { Menu as BaseMenu, Group } from '@calendly/ui/components/menu';
import { ControlUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import React, { useEffect, useState, forwardRef } from 'react';
import SearchInput from 'components/core/search_input';
import { OptionsContainer, Option } from './option';
import { PillControl, Pills } from './pills';
const containerCss = "cebd37m";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledFixedContainerCss = "su5eou4";
const StyledFixedContainer = forwardRef((props, ref) => <FixedContainer ref={ref} {...props} className={classNames(styledFixedContainerCss, props.className)} />);
const menuCss = "m2bu36k";
const Menu = forwardRef((props, ref) => <BaseMenu ref={ref} {...props} className={classNames(menuCss, props.className)} />);
const helpTextCss = "htwp7r9";
const HelpText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(helpTextCss, props.className)} />;
});
const searchContainerCss = "s1gxsu6k";
const SearchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(searchContainerCss, props.className)} />;
});
const formatStringForSearch = string => string.toLowerCase().replace(' ', '');
const MenuContent = ({
  collection,
  disableSearch = false,
  formatter,
  helpText,
  isError,
  isLoading,
  maxLimit,
  searchTerm,
  selectedItems,
  setSearchTerm,
  toggleSelected
}) => {
  if (isLoading) {
    return <BodyText>{I18n.t('publisher.messages.loading')}</BodyText>;
  }
  if (isError) {
    return <BodyText>{I18n.t('publisher.organization.reporting.titles.load_error')}</BodyText>;
  }
  return <>
      {!disableSearch && <SearchContainer>
        <SearchInput autoFocus placeholder={I18n.t('publisher.organization.reporting.search_placeholder')} onChange={setSearchTerm} />
      </SearchContainer>}
      <OptionsContainer>
        {helpText && <HelpText>
          {helpText}
        </HelpText>}
        <Group>
          {collection.filter(item => formatStringForSearch(item.name).includes(formatStringForSearch(searchTerm))).map(item => {
          const isSelected = !!selectedItems.some(({
            uri
          }) => item.uri === uri);
          return <Option disabled={isSelected ? false : maxLimit <= selectedItems.length} formatter={formatter} item={item} key={item.uri} onClick={toggleSelected} selected={isSelected} />;
        })}
        </Group>
      </OptionsContainer>
    </>;
};
export const SearchFacet = ({
  allSelectedText = '',
  collection = [],
  disabled = false,
  disableSearch = false,
  formatter,
  helpText = '',
  isError = false,
  isLoading = false,
  maxLimit,
  onSelect = () => {},
  selected = [],
  title = ''
}) => {
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const [selectedItems, setSelectedItems] = useState(selected);
  const [searchTerm, setSearchTerm] = useState('');
  const Control = selectedItems.length > 0 ? PillControl : ControlUI;
  const label = React.isValidElement(title) ? title.props.children : title;
  const selectedPillItems = selectedItems?.length > 0 ? selectedItems.map(({
    uri
  }) => collection.find(item => item.uri === uri)).filter(Boolean) : null;
  const addToSelected = item => {
    onSelect(items => [...items, item]);
    if (maxLimit === 1) toggleDropdown();
  };
  const removeFromSelected = item => {
    onSelect(selectedItems.filter(({
      uri
    }) => uri !== item.uri));
  };
  const toggleSelected = item => {
    if (!selectedItems.some(({
      uri
    }) => uri === item.uri)) {
      addToSelected(item);
    } else {
      removeFromSelected(item);
    }
  };
  useEffect(() => {
    setSelectedItems(selected);
    return () => {};
  }, [selected]);
  useEffect(() => {
    if (!isOpen) {
      setSearchTerm('');
    }
    return () => {};
  }, [isOpen]);
  return <Container>
      {title && <BodyText color="muted" weight="bold">{title}</BodyText>}
      <Control expanded={isOpen} onClick={toggleDropdown} disabled={disabled} aria-label={label}>
        {selectedPillItems ? <Pills items={selectedPillItems} onClick={removeFromSelected} /> : allSelectedText}
      </Control>
      <Dropdown>
        <Menu>
          <MenuContent collection={collection} disableSearch={disableSearch} formatter={formatter} helpText={helpText} isError={isError} isLoading={isLoading} maxLimit={maxLimit} searchTerm={searchTerm} selectedItems={selectedItems} setSearchTerm={setSearchTerm} toggleSelected={toggleSelected} />
        </Menu>
      </Dropdown>
      {isOpen && <StyledFixedContainer fixedWhen />}
    </Container>;
};

require("./search_facet.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_facet.js");